<div class="w-full flex justify-center">
  <div class="max-w-[1800px] w-full">
    <zaeper-page-layout [navigation]="navigation" [pageLayout]="ePageLayout.CARDS"
      [title]="('manage-receivers' | zDictionary)">
      <ng-template zTemplate="header">
        <zaeper-icon fontSet="material-icons-outlined">tv_outline</zaeper-icon>
      </ng-template>

      <div class="flex flex-col gap-6">
        <div class="flex justify-between">
          <!-- TabNavigation -->
          <div class="flex flex-row gap-2">
            <!-- Shown to everyone, disabled with the role it needs: users see what their role can't do. -->
            <span class="inline-flex" [pTooltip]="(isManager$ | async) ? undefined : ('MANAGER' | zRole: 'hint')" tooltipPosition="top">
              <p-button [disabled]="!(isManager$ | async)" (onClick)="openConnectReceiverModal()" [label]="'add-receiver' | zDictionary" [rounded]="true"
            icon="pi pi-plus"></p-button>
            </span>
            <span class="inline-flex" [pTooltip]="(isEditor$ | async) ? undefined : ('EDITOR' | zRole: 'hint')" tooltipPosition="top">
              <p-button [disabled]="!(isEditor$ | async)" (onClick)="syncReceiverSettings()" [label]="'Receivers synchronisieren'" [outlined]="true"
            [rounded]="true" icon="pi pi-sync"></p-button>
            </span>
          </div>

          <p-iconfield class="self-center">
            <p-inputicon styleClass="pi pi-search"/>
            <input #globalFilter [placeholder]="'search' | zDictionary: 'main'" pInputText type="text"/>
          </p-iconfield>
        </div>

        <p-table (onLazyLoad)="lazyLoadTable($event)" [lazy]="true" [loading]="(isLoading$ | async) ?? true"
          [paginator]="true" [rowsPerPageOptions]="rowsPerPageOptions" [rows]="10"
          [showLoader]="false" [tableStyle]="{ 'min-width': '50rem' }" [totalRecords]="(totalRecords$ | async) || 0"
          [value]="(records$ | async) || []">
          <ng-template let-columns="columns" pTemplate="loadingbody">
            @for (i of (skeletonRows$ | async); track i) {
              <tr>
                @for (_ of [].constructor(9); track $index) {
                  <td>
                    <p-skeleton height="2rem"></p-skeleton>
                  </td>
                }
              </tr>
            }
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>#</th>
              <th class="whitespace-nowrap">Online</th>
              <th class="whitespace-nowrap w-full">Name</th>
              <th class="whitespace-nowrap">OS Typ</th>
              <th class="whitespace-nowrap">OS Version</th>
              <th class="whitespace-nowrap">App Version</th>
              <th class="whitespace-nowrap">Zuletzt aktualisiert</th>
              <th class="whitespace-nowrap">Status</th>
              <th class="whitespace-nowrap">Aktionen</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="8" class="text-center">
                Keine Einträge gefunden
              </td>
            </tr>
          </ng-template>
          <ng-template let-i="rowIndex" let-receiverRecord pTemplate="body">
        <tr [ngClass]="{
          'bg-surface-100 dark:bg-surface-800': ((totalRecords$ | async) ?? 0) > 1 && (receiverRecord.id === (activeReceiver$ | async)?.id)
        }">
              <td>{{ i + 1 }}</td>
              <td class="whitespace-nowrap text-center">
                @if (receiverRecord.isOnline) {
                  <div class="inline-block h-[10px] w-[10px] rounded-full bg-zaeper-success-500"></div>
                } @else {
                  <div class="inline-block h-[10px] w-[10px] rounded-full bg-surface-400 dark:bg-surface-500"></div>
                }
              </td>
              <td class="whitespace-nowrap"><strong>{{ receiverRecord.name }}</strong></td>
              <td class="whitespace-nowrap"><i>{{ receiverRecord.osType }}</i></td>
              <td class="whitespace-nowrap"><i>{{ receiverRecord.osVersion }}</i></td>
              <td class="whitespace-nowrap"><i>{{ receiverRecord.appVersion }}</i></td>
              <td class="whitespace-nowrap"><i>08.04.2024 03:41Uhr</i></td>
              <td class="whitespace-nowrap"><i>Aktuell</i></td>
              <td>
                <div class="flex gap-2 justify-end items-center h-full w-full">
                  <span class="inline-flex" [pTooltip]="(isManager$ | async) ? undefined : ('MANAGER' | zRole: 'hint')" tooltipPosition="top">
                    <p-button [disabled]="!(isManager$ | async)" (onClick)="delete(receiverRecord.id)" [outlined]="true" [rounded]="true" icon="pi pi-trash"
                    label="" severity="danger"/>
                  </span>
                  <span class="inline-flex" [pTooltip]="(isEditor$ | async) ? undefined : ('EDITOR' | zRole: 'hint')" tooltipPosition="top">
                    <p-button [disabled]="!(isEditor$ | async)" (onClick)="openPushReceiverConfigModal()" [outlined]="true" [rounded]="true"
                    icon="pi pi-cloud-download"/>
                  </span>
                  <span class="inline-flex" [pTooltip]="(isEditor$ | async) ? undefined : ('EDITOR' | zRole: 'hint')" tooltipPosition="top">
                    <p-button [disabled]="!(isEditor$ | async)" (onClick)="openScheduleReceiverConfigPushModal()" [outlined]="true" [rounded]="true"
                    icon="pi pi-calendar-plus"/>
                  </span>
                  <p-button (onClick)="switchToReceiver(receiverRecord)" [outlined]="true"
                    [rounded]="true" icon="pi pi-desktop"/>
                  <span class="inline-flex" [pTooltip]="(isEditor$ | async) ? undefined : ('EDITOR' | zRole: 'hint')" tooltipPosition="top">
                    <p-button [disabled]="!(isEditor$ | async)" (onClick)="openApplicationsOverviewModal(receiverRecord)" [rounded]="true"
                    styleClass="whitespace-nowrap">Konfigurieren
                  </p-button>
                  </span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </zaeper-page-layout>
  </div>
</div>
